import type { ApiResponse, Program } from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import { shouldRetryDashboardQuery } from '@/libs/query-client';

export const fetchProgramById = async (id: string): Promise<Program> => {
  try {
    const response = await api.get<ApiResponse<Program>>(`/dashboard/programs/${id}`);

    console.log('fetchProgramById - API Response:', response.data);

    if (!response.data || !response.data.data) {
      throw new Error('Program not found or invalid response structure');
    }

    return response.data.data;
  } catch (error) {
    console.error('fetchProgramById - Error:', error);
    throw error;
  }
};

interface UseAffiliateProgramQueryProps {
  programId: string | undefined | null;
  enabled?: boolean;
  initialData?: Program;
}

const AFFILIATE_PROGRAM_QUERY_KEY_PREFIX = 'program';

export const useProgramQuery = ({
  programId,
  enabled = true,
  initialData,
}: UseAffiliateProgramQueryProps): UseQueryResult<Program, Error> => {
  return useQuery<Program, Error, Program, [string, string | undefined | null]>({
    queryKey: [AFFILIATE_PROGRAM_QUERY_KEY_PREFIX, programId],
    queryFn: () => {
      if (!programId) {
        return Promise.reject(new Error('Program ID is required.'));
      }
      return fetchProgramById(programId);
    },
    enabled: !!programId && enabled,
    initialData,
    retry: (failureCount, error) => shouldRetryDashboardQuery(failureCount, error, 1),
  });
};
